import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';

import useColorSystem from '../../../hook/useColorSystem';

import { SearchInputBlueMain } from '../../customComponent/form';

import { SearchIcon, DeleteOutlineOutlinedIcon } from '../../../constants/images';

import theme from '../../../theme';


const fieldsBlockHeight = '540px';

const TaboolaFieldsAllMetric = ({
  filterOptionFields,
  selectedOptionFields,
  searchKeyword,
  setSearchKeyword,
  handleModalDetail,
  handleTitle,
  changeOptionFields,
  changeAllConvertionsFields,
  handleDeleteFields }) => {
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const [showButton, setShowButton] = useState(false);

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
  };

  const handleshowButton = (field, method) => {
    if (field.type === 'CUSTOM' && !field.cid) {
      method === 'enter' ? setShowButton(true) : setShowButton(false);
    }
  }

  const checkFieldIsSelected = (currentData, originalData) => {
    return _.findIndex(currentData, ['expression', originalData]) > -1 ? true : false;
  }

  const checkAllFieldsSelected = (selectedFields, allFields) => {
    const duplicateFields = _.intersectionBy(selectedFields, allFields, 'expression');
    return duplicateFields.length === allFields.length ? true : false;
  }

  const checkPartiallyFieldsSelected = (selectedFields, allFields) => {
    const duplicateFields = _.intersectionBy(selectedFields, allFields, 'expression');
    const isAllSelected = duplicateFields.length === allFields.length;
    return (duplicateFields.length && !isAllSelected) ? true : false;
  }

  const generalFields = (item, index, elCategory) => {
    const title = elCategory === 'custom' ? handleTitle(item) : null;

    return (
      <Stack
        key={`${item.expression}_${index}`}
        variant='between-center'
        onMouseEnter={() => handleshowButton(item, 'enter')}
        onMouseLeave={() => handleshowButton(item, 'leave')}
      >
        <>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                name={item.expression}
                color={colorMedia}
                sx={{ paddingTop: 0, paddingBottom: '2px' }}
                checked={checkFieldIsSelected(selectedOptionFields, item.expression)}
                onChange={(e) => changeOptionFields(e, item)}
              />
            }
            label={item.name}
            title={title}
            sx={{ display: 'block', marginBottom: '6px' }}
          />
          {showButton && item.type === 'CUSTOM' && !item.cid && (
            <Tooltip title="刪除指標">
              <DeleteOutlineOutlinedIcon
                variant="dark"
                sx={{
                  marginRight: '8px',
                  marginBottom: '8px',
                  '&:hover': { color: mainColor, cursor: 'pointer' }
                }}
                onClick={(e) => handleDeleteFields(e, item, 'deletefield')}
              />
            </Tooltip>
          )}
        </>
      </Stack>
    )
  }

  const customConvertionsFields = (el) => {
    const groupFields = (fields) => {
      return fields.reduce((groups, item) => {
        const [groupName] = item.name.split(': ');
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(item);
        return groups;
      }, {});
    }
    const groupedFields = groupFields(el.child);

    return (
      <Box>
        {Object.keys(groupedFields).map((groupName, index) => (
          <Box key={`${groupName}_${index}`} sx={{ marginBottom: '14px' }}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name={groupName}
                  color={colorMedia}
                  sx={{ paddingTop: 0, paddingBottom: '2px' }}
                  checked={checkAllFieldsSelected(selectedOptionFields, groupedFields[groupName])}
                  indeterminate={checkPartiallyFieldsSelected(selectedOptionFields, groupedFields[groupName])}
                  onChange={(e) => changeAllConvertionsFields(e, groupedFields[groupName])}
                />
              }
              label={
                <span style={{ fontWeight: 'bold' }}>
                  {groupName}
                </span>
              }
              sx={{ display: 'block', marginBottom: '6px' }}
            />
            <FormGroup>
              {groupedFields[groupName].map((item) => (
                <FormControlLabel
                  key={item.expression}
                  control={
                    <Checkbox
                      size="small"
                      name={item.expression}
                      color={colorMedia}
                      sx={{ paddingTop: 0, paddingBottom: '2px' }}
                      checked={checkFieldIsSelected(selectedOptionFields, item.expression)}
                      onChange={(e) => changeOptionFields(e, item)}
                    />
                  }
                  label={item.name}
                  sx={{ display: 'block', marginBottom: '6px' }}
                />
              ))}
            </FormGroup>
          </Box>
        ))}
      </Box>
    )
  }

  const categoryFields = (el) => {
    const mainTitle = el.name === '自訂轉換欄' ? el.category : null;

    return (
      <Box key={el.category}>
        {el.child?.length > 0 && (
          <>
            <Typography
              sx={{
                marginBottom: '8px',
                padding: '4px 0 4px 8px',
                backgroundColor: theme.palette.grey.w100,
                borderRadius: '2px',
              }}
              title={mainTitle}
            >
              {el.name}
            </Typography>

            <Box pl={0.5} pb={1}>
              {el.name !== '自訂轉換欄' &&
                el.child.map((item, index) => generalFields(item, index, el.category))
              }
              {el.name === '自訂轉換欄' &&
                customConvertionsFields(el)
              }
            </Box>
          </>
        )}
      </Box>
    )
  }

  return (
    <Box sx={{ flex: 1, borderRight: `1px solid ${theme.palette.grey.w300}` }}>
      <Box sx={{ padding: '16px 16px 4px 16px' }} >
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            paddingBottom: '4px',
            borderBottom: `1px solid ${theme.palette.grey.w300}`
          }}
        >
          所有欄位
          <Typography
            variant="caption"
            sx={{ cursor: 'pointer', color: mainColor }}
            onClick={() => handleModalDetail('create_custom_metric')}
          >
            建立自訂衡量指標
          </Typography>
        </Typography>

        <SearchInputBlueMain
          id="search"
          placeholder="搜尋欄位名稱"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          value={searchKeyword}
          onChange={handleSearchInput}
          sx={{ width: "100%", marginTop: "10px" }}
        />
      </Box>

      <Box
        pt={1}
        sx={{
          height: fieldsBlockHeight,
          overflow: 'auto',
          paddingLeft: '16px',
          paddingRight: '8px',
        }}
      >
        {filterOptionFields.map((el) => categoryFields(el))}
      </Box>

    </Box>
  )
}

export default TaboolaFieldsAllMetric;